import React from 'react';
import { Users, Building, Briefcase, Target } from 'lucide-react';

const WhoItsFor = () => {
  const targetAudience = [
    {
      icon: <Users className="h-8 w-8 text-burnt-orange" />,
      title: "Founders and CEOs",
    },
    {
      icon: <Building className="h-8 w-8 text-burnt-orange" />,
      title: "Agency owners & consultants",
    },
    {
      icon: <Briefcase className="h-8 w-8 text-burnt-orange" />,
      title: "Busy executives and operators",
    },
    {
      icon: <Target className="h-8 w-8 text-burnt-orange" />,
      title: "Leaders juggling clients, teams, and decisions",
    }
  ];

  return (
    <section id="who-its-for" className="section-padding bg-white">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            Built for people carrying real responsibility.
          </h2>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-xl text-olive-brown/80 mb-8">FractionalVa is for:</p>
          </div>
          
          {/* Target Audience Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {targetAudience.map((item, index) => (
              <div 
                key={index}
                className="flex items-center space-x-4 p-6 bg-gray-50 rounded-xl card-shadow animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="p-3 bg-white rounded-full">
                  {item.icon}
                </div>
                <h3 className="text-lg font-medium text-olive-brown">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
          
          {/* Closer Line */}
          <div className="text-center pt-8 border-t border-olive-brown/20">
            <p className="text-xl font-medium text-olive-brown">
              If you're tired of always catching up, we should talk.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;